import React from 'react';
import TreatmentConsentLandingPage from './TreatmentConsentLandingPage';

export default function CompositeBondingConsentFormUk() {
  return (
    <TreatmentConsentLandingPage
      title="Composite Bonding Consent Form UK | Cosmetic Dental Consent | Smile Consent"
      description="Create a composite bonding consent form for UK practices with AI-assisted drafting, digital signing, and clearer records for limitations, maintenance, and replacement."
      canonicalUrl="https://smileconsent.co.uk/composite-bonding-consent-form-uk"
      h1="Composite Bonding Consent Form for UK Practices"
      treatmentName="Composite bonding consent form"
      intro="Create composite bonding consent forms with clearer discussion of cosmetic limitations, maintenance, longevity, and digital signing for UK dental practices."
      risks={[
        'Likely cosmetic improvement, treatment limitations, and the possibility that expectations may need careful management.',
        'Material risks such as chipping, staining, wear, marginal breakdown, and the need for maintenance or replacement over time.',
        'Alternatives including whitening, orthodontics, veneers, no treatment, or more extensive restorative options where relevant.',
        'Ongoing maintenance requirements, polishing, review appointments, and patient responsibilities for care.',
        'Private treatment costs, repair or replacement costs, and the expected lifespan of the restoration.',
      ]}
      relatedLinks={[
        { title: 'Veneer consent form UK', description: 'Consent wording for porcelain or composite veneers', path: '/veneer-consent-form-uk' },
        { title: 'Implant consent form UK', description: 'Treatment-specific consent for implant cases', path: '/implant-consent-form-uk' },
        { title: 'AI dental consent forms', description: 'See all treatment-specific consent workflows', path: '/dental-consent-forms' },
      ]}
    />
  );
}
